module.exports = __webpack_public_path__ + "8da36a67fd703d63978224f008ff7633.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-8.png
// module id = 1619
// module chunks = 0